import { Button, type ButtonProps } from '@iconik-io/uad';

import { useFormContext } from '../app_form_context';

type CancelButtonProps = Omit<ButtonProps, 'type' | 'onPress'> & {
  onPress?: ButtonProps['onPress'];
};

/**
 * Cancel button that resets the form before running the provided press handler.
 *
 * Must be rendered inside a `<form.AppForm>` wrapper.
 */
export function CancelButton(props: CancelButtonProps) {
  const { children = 'Cancel', onPress, isDisabled, ...rest } = props;
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button
          type="button"
          variant="tertiary"
          isDisabled={isSubmitting || isDisabled}
          {...rest}
          onPress={(event) => {
            form.reset();
            onPress?.(event);
          }}
        >
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
}
